import { createSelector } from '@reduxjs/toolkit';

const _getValidarionErrors = (state) => state.get('validation');
export const getValidarionErrors = createSelector(
  _getValidarionErrors,
  (errors) =>
    errors.reduce((result, current) => {
      result[current.path.split('.')[1]] = current.message; // eslint-disable-line no-param-reassign
      return result;
    }, {}),
);
export const getFirstValidationError = createSelector(
  _getValidarionErrors,
  (errors) => errors.get(0) || null,
);
const _getTouristErrors = (state, idx) =>
  _getValidarionErrors(state).filter((error) =>
    error.path.startsWith(`[${idx}]`),
  );

const _makeTouristErrors = (state, idx) =>
  _getTouristErrors(state, idx).reduce((result, current) => {
    result[current.path.split('.')[1]] = current.message; // eslint-disable-line no-param-reassign
    return result;
  }, {});

export const getFirstTouristError = createSelector(
  _getTouristErrors,
  (errors) => errors.get(0) || null,
);

// TODO: THINK ABOUT IT
// const _getFieldErrorz = (state, props) => _getTouristErrors(state, props)
// .filter(error => error.path.split('.')[1] === props.stateField);
// export const makeGetFieldError = () => createSelector(
//   [_getFieldErrorz],
//   (errors) => {
//     const [error] = errors.toJS();
//     return error ? error.message : null;
//   },
// );
export const makeGetTouristErrors = () =>
  createSelector([_makeTouristErrors], (errors) => errors);
